export { default } from "./WritePromptIcon.js";
